import Papa from 'papaparse';

export default class CSVUtils {
    /**
     * Parse a csv file and returns a Promise which resolves to the data as an array
     * Let's parse CSV data as big fumiers ! xD
     * @param File file
     */
    static getDataFromCSVFile(file, action, { header = true, delimiter = ',', encoding = 'utf-8', preview = 0 } = {}) {
        if (!/\.csv$/.test(file.name)) {
            // console.log('Not a CSV', file.name, file);
        }

        // Get CSV file contents as a string
        const reader = new FileReader();
        reader.addEventListener('load', function () {
            // Parse the csv string and returns a Promise which resolves to the data as an array
            Papa.parse(this.result as any, {
                header,
                preview,
                delimiter,
                skipEmptyLines: true,
                //quoteChar: '"',
                complete: (results) => {
                    action(results.data);
                },
                error: (err, file) => {
                    const msg = 'CSV file parsing step encountered an error...';
                    action(null, err, msg);
                },
            });
        });
        reader.readAsText(file, encoding);
    }

    /**
     * From Data to CSV
     * @param contents the datas to put into csv format
     */
    static getCSVfromData(contents, delimiter = ',') {
        return Papa.unparse(contents, {
            skipEmptyLines: true,
            delimiter,
        });
    }
}
